import React, { forwardRef } from 'react';
import { renderPathForWeight } from '../../lib/index.esm.js';
import IconBase from '../../lib/IconBase.esm.js';

/* GENERATED FILE */
var pathsByWeight = /*#__PURE__*/new Map();
pathsByWeight.set('fill', function () {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M207.99414,32h-160a16.01583,16.01583,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01582,16.01582,0,0,0,207.99414,32ZM167.60352,139.71875l-33.94336,33.92773a8.02367,8.02367,0,0,1-11.332,0L88.40039,139.71875a7.99915,7.99915,0,0,1,11.3125-11.3125l20.28125,20.28125V88a8,8,0,1,1,16,0v60.69238L156.291,128.40625a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
  }));
});
pathsByWeight.set('regular', function (color) {
  return React.createElement(React.Fragment, null, React.createElement("rect", {
    x: "40",
    y: "40",
    width: "176",
    height: "176",
    rx: "8",
    strokeWidth: "16",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), React.createElement("polyline", {
    points: "94.059 134.059 128 168 161.941 134.059",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "16"
  }), React.createElement("line", {
    x1: "128",
    y1: "88",
    x2: "128",
    y2: "168",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "16"
  }));
});

var renderPath = function renderPath(weight, color) {
  return renderPathForWeight(weight, color, pathsByWeight);
};

var ArrowSquareDown = /*#__PURE__*/forwardRef(function (props, ref) {
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, props, {
    viewBox: "0 0 256 256",
    renderPath: renderPath
  }));
});
ArrowSquareDown.displayName = 'ArrowSquareDown';

export default ArrowSquareDown;
//# sourceMappingURL=ArrowSquareDown.esm.js.map
